import 'whatwg-fetch';
import results from '../data/results';

/**
 * @params { array } responses
 * @return { object } result
 */
export function getResult(responses) {
  const stats = {};
  const wantedTag = {};

  let statsKeys = null;

  for (let i = 0; i < responses.length; i += 1) {
    const r = responses[i];
    const rt = (r.end - r.start) / (1000 * 60);
    const score = Math.min(1, 1 / (1 + Math.abs(rt - 0.5)));

    // calculate score for each tag
    if (!stats[r.tag]) {
      stats[r.tag] = 0;
    }

    if (!stats[r.theOther]) {
      stats[r.theOther] = 0;
    }

    stats[r.tag] += score;
    stats[r.theOther] -= score;
  }

  // find the tag with highest score as wanted result tag
  statsKeys = Object.keys(stats);

  for (let i = 0; i < statsKeys.length; i += 1) {
    const key = statsKeys[i];
    const score = stats[key];

    if (!wantedTag.score) {
      wantedTag.tag = key;
      wantedTag.score = score;
    }
    if (wantedTag.score < score) {
      wantedTag.tag = key;
      wantedTag.score = score;
    }
  }

  // find the final result data
  for (let i = 0; i < results.length; i += 1) {
    if (results[i].tag === wantedTag.tag) {
      return results[i];
    }
  }

  return null;
}

export function postResult(responses, emotion) {
  const url = 'https://relab.cc/gp-shopholic-db/index.php/data';
  const data = {};

  responses.forEach((r, i) => {
    data[`q${i + 1}`] = r.tag;
    data[`q${i + 1}x`] = r.theOther;
    data[`q${i + 1}t`] = r.end - r.start;
  });

  data.q10 = emotion.join(',');

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => res.json());
//    .then((json) => {
//      console.log(json);
//    });
}



// WEBPACK FOOTER //
// ./app/utils/result-handler.js